<template>
  <div class="row">
    <div
      v-for="(activitiesInThatCategory, category) in availableActivitiesPerCategoy"
      :key="category"
      class="col">
      <div v-for="(activity, index) in activitiesInThatCategory" :key="index" class="form-check">
        <input
          type="radio"
          class="form-check-input"
          :checked="internalActivityId != null && internalActivityId == activity.id"
          @change="onActivitySelected(activity, $event.target.checked)">
        <label class="form-check-label">{{ activity.icon }} {{ activity.name }}</label>
      </div>
    </div>
  </div>  
</template>

<script>

import { useActivitiesStore } from "@/stores/activities";

export default {
  name: "ActivityForm",
  props: {
    modelValue: { // The activity id
      type: Number,
      required: false,
      default: null,
    },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      activitiesStore: useActivitiesStore(),
      internalActivityId: this.modelValue,
    };
  },
  computed: {
    availableActivitiesPerCategoy() {
      if (this.availableActivities == null || this.availableActivities.length == 0) {
        return {};
      }

      const res = {};

      this.availableActivities.forEach((activity) => {
        if (!res[activity.category]) {
          res[activity.category] = [];
        }
        res[activity.category].push(activity);
      });

      Object.values(res).forEach((activities) => {
        activities.sort((a, b) => {
          return a.order < b.order;
        });
      });

      return res;
    },
    availableActivities() {
      return this.activitiesStore.getActivitiesForCustomerCallCreationForm;
    },
  },
  watch: {
    modelValue(newValue) {
      this.internalActivityId = newValue;
    },
  },
  methods: {
    onActivitySelected(activity) {
      this.internalActivityId = activity.id;
      this.$emit("update:modelValue", this.internalActivityId);
      this.$emit("change", this.internalActivityId);
    },
  },
};
</script>
